module.exports = __webpack_public_path__ + "img/about_exh3_en.f4809ff2.jpg";